<template>
  <div class="t-day t-day_hover" v-if="active" :class="{'t-day_disabled': !place && !select, 't-day_select': select, 't-day_small': mobileCalendar, '_today': today}" @click.prevent="SelectDate(id)">
    <p class="t-day__date">{{ day }}</p>
    <template v-if="active && !mobileCalendar" >
      <p class="t-day__name">{{ title }}</p>
      <p class="t-day__time">{{ time }}</p>
    </template>
  </div>
  <div class="t-day t-day_notActive" :class="{'t-day_small': mobileCalendar, '_today': today}" v-else>
    <p class="t-day__date">{{ day }}</p>
  </div>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex';

    export  default {
        props: ['day'],
        data(){
            return{
                title: '',
                time: '',
                count: 0,
                id: [],
                select: false,
                place: false,

                today: false
            }
        },
        computed: {
            ...mapGetters(['mobileCalendar']),
            ...mapGetters('profile', ['hasAuth']),
            ...mapGetters('calendar', ['date_active', 'filter', 'calendarText']),
            ...mapGetters('coursesList', ['course', 'streams']),
            active(){
                this.title = '';
                this.time = '';
                this.count = 0;
                this.id = [];
                this.select = false;
                this.place = false;

                let lessons_count = 0;

                if(this.streams.length){
                    let applications = 0;
                    let new_applications = 0;

                    let date = this.date_active.getFullYear() + '.' + (this.date_active.getMonth() + 1) + '.' + this.day;

                    let today = new Date(),
                        today_text = today.getFullYear() + '.' + (today.getMonth() + 1) + '.' + today.getDate();

                    this.today = today_text === date;

                    if(this.course.type === 3){
                        let stream = this.streams[this.filter.value.value];
                        if (stream) {
                          for(let l = 0; l < stream.lessons.length; l++){
                            let lesson = stream.lessons[l];

                            let day = new Date(lesson.date_time);
                            let date_2 = day.getFullYear() + '.' + (day.getMonth() + 1) + '.' + day.getDate();

                            if(date_2 === date){
                              lessons_count++;
                              this.id.push(stream.id);

                              if(this.course.belonging){
                                new_applications += stream.applications.new;
                                applications += stream.applications.confirmed;

                                this.title = applications + ' ' + this.declOfNum(applications, this.calendarText.applicationArr);
                                this.time = new_applications + ' ' + this.declOfNum(new_applications, this.calendarText.applicationNewArr);

                                this.place = true;
                              } else{
                                let time_start = [];
                                time_start.push(day.getHours() < 10 ? '0' + day.getHours() : day.getHours());
                                time_start.push(day.getMinutes() < 10 ? '0' + day.getMinutes() : day.getMinutes());

                                if(stream.select){
                                  this.time += time_start.join(':') + ', ';

                                  this.select = true;
                                  if(l === 0)
                                    this.title = this.calendarText.myApplication;
                                  else
                                    this.title = (l + 1) + ' ' + this.calendarText.lesson;
                                } else{
                                  if(!this.select){
                                    this.time += time_start.join(':') + ', ';

                                    this.title = (l + 1) + ' ' + this.calendarText.lesson;
                                    if(stream.place && stream.choose){
                                      this.place = true;
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                    } else{
                        for(let s = 0; s < this.streams.length; s++){
                            let stream = this.streams[s];

                            for(let l = 0; l < stream.lessons.length; l++) {
                                let lesson = stream.lessons[l];

                                let day = new Date(lesson.date_time);
                                let date_2 = day.getFullYear() + '.' + (day.getMonth() + 1) + '.' + day.getDate();

                                if(date_2 === date){
                                    lessons_count++;
                                    this.id.push(stream.id);

                                    if(this.course.belonging){
                                        new_applications += stream.applications.new;
                                        applications += stream.applications.confirmed + stream.applications.closed + stream.applications.pending;

                                        this.title = applications + ' ' + this.declOfNum(applications, this.calendarText.applicationArr);
                                        this.time = new_applications + ' ' + this.declOfNum(new_applications, this.calendarText.applicationNewArr);

                                        this.place = true;
                                    } else{
                                        let time_start = [];
                                        time_start.push(day.getHours() < 10 ? '0' + day.getHours() : day.getHours());
                                        time_start.push(day.getMinutes() < 10 ? '0' + day.getMinutes() : day.getMinutes());

                                        if(stream.select){
                                            this.time += time_start.join(':') + ', ';

                                            this.select = true;
                                            this.title = this.calendarText.myApplication;
                                        } else{
                                            if(!this.select){
                                                this.time += time_start.join(':') + ', ';

                                                if(stream.place && stream.choose){
                                                    this.place = true;
                                                    this.title = this.calendarText.placeYes;
                                                } else{
                                                    if(!stream.choose){
                                                        this.title = this.calendarText.lessonEnd;
                                                    } else{
                                                        if(!this.place){
                                                            this.title = this.calendarText.placeNo;
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    if(!this.course.belonging)
                        this.time = this.time.substring(0, this.time.length - 2);
                }

                return lessons_count > 0
            }
        },
        methods: {
            ...mapActions('modal', ['modalDialogType_authOpen']),
            declOfNum(n, titles) {
                return titles[(n % 10 === 1 && n % 100 !== 11) ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2]
            },
            ...mapActions('coursesList', ['setStreamId']),
            ...mapActions('modal', ['modalDialogType_signUpOpen']),
            SelectDate(e){
                if(this.hasAuth){
                    if(!this.select && !this.course.belonging){
                        this.setStreamId(e);
                        this.modalDialogType_signUpOpen();
                    } else {
                        if (this.course.belonging) {
                            let date = this.date_active.getFullYear() + '.' + (this.date_active.getMonth() + 1) + '.' + this.day;
                            this.$router.push({
                                name: 'courses_applications',
                                params: {id: this.course.id, slug: this.course.slug},
                                query: {date: date}
                            });
                        }
                    }
                } else{
                    this.modalDialogType_authOpen();
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/vue_components/Calendar/View/Day.vue